import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgMe(props: RootSvgProps) {
  return (
    <RootSvg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_4628_55457)">
        <path
          d="M10.0006 4.91536C10.9673 4.91536 11.7506 5.6987 11.7506 6.66536C11.7506 7.63203 10.9673 8.41536 10.0006 8.41536C9.03398 8.41536 8.25065 7.63203 8.25065 6.66536C8.25065 5.6987 9.03398 4.91536 10.0006 4.91536ZM10.0006 12.4154C12.4756 12.4154 15.084 13.632 15.084 14.1654V15.082H4.91732V14.1654C4.91732 13.632 7.52565 12.4154 10.0006 12.4154ZM10.0006 3.33203C8.15898 3.33203 6.66732 4.8237 6.66732 6.66536C6.66732 8.50703 8.15898 9.9987 10.0006 9.9987C11.8423 9.9987 13.334 8.50703 13.334 6.66536C13.334 4.8237 11.8423 3.33203 10.0006 3.33203ZM10.0006 10.832C7.77565 10.832 3.33398 11.9487 3.33398 14.1654V16.6654H16.6673V14.1654C16.6673 11.9487 12.2256 10.832 10.0006 10.832Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4628_55457">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
